import React, { useState } from 'react';
import  {Tooltip, Button, Dialog, Classes, Intent}  from "@blueprintjs/core";
import Endpoints from "../../../endpoints.js";

/**
 *
 * @param {Object} props
 * @param {Agente} props.currentAgent
 * @returns {JSX.Element}
 * @constructor
 */
function MessageTemplateDialog(props) {
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [loading, setLoading] = useState(false);
  const [dynamicParams, setDynamicParams] = useState({});
  const [preview, setPreview] = useState('');

  const [image, setImage] = useState('')

  const handleSubmit = (e) =>{
    e.preventDefault();

    document.getElementById('div-status').innerHTML ='';

    const recipient = props.defaultValue;

    setLoading(true)

    const shouldIncludeHeader = selectedTemplate.hasOwnProperty("header") && selectedTemplate.header.type === "image";

    const header = {
      type: "image",
      image: {
        link: image ? image : null
      }
    }
    console.log('Parametros1');
    console.log(dynamicParams);
    fetch(Endpoints().GCP_SEND_TEMPLATE_URL, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer "+ props.currentAgent.stsTokenManager.accessToken
      },
      body: JSON.stringify({
        broadcast: true,
        action: selectedTemplate.id,
        payload:{
          recipient: recipient,
          requester_name: props.currentAgent.displayName,
          params: {
            body: dynamicParams,
            header: shouldIncludeHeader ? header : null
          }
        },
        agent_email: props.currentAgent.usuario.emailreal,
        agent_group: props.currentAgent.usuario.group
      })
    })
    .then((response) => {
      if(response.ok){
        setPreview('');
        setDynamicParams({});
        props.close();
      }else{
        document.getElementById('div-status').innerHTML = `El número <b>${recipient}</b> no se encuentra disponible en Whatsapp.`;
      }
    })
    .finally(() => {
      setLoading(false)
      setSelectedTemplate('')
      setImage(false)
    });
  }

  const handleChange = (e) =>{
    const id = e.target.value;

    if(id === "") { return setPreview('') };

    const template = props.templateList.find(x => x.id === id);

    const previewValue = template.text
      .replace(/~([^~]*)~/g, '<del>$1</del>')
      .replace(/_([^_]*)_/g, '<em>$1</em>')
      .replace(/\*([^*]*)\*/g, '<strong>$1</strong>')
      .replace(/```(.*)```/g, '<code>$1</code>')
      .replace(/\n/g, '<br/>');

    setSelectedTemplate(template);
    setPreview(previewValue);
  }

  const handleChangeImage = (e) =>{
    //console.log(e.target)
    const src = e.target.value;

    if(src === "") { return null };
    
    setImage(src)
    //alert(image)
  }

  const handleChangeOnDynamic = (data, event) => {
    const index = data + 1;

    const tmp = {
      [index]: {
        Type: "text",
        Text: event.target.value,
        Order: index
      }
    }
    console.log(tmp);
    const newState = Object.assign({}, dynamicParams, tmp)

    const previewValue = selectedTemplate.text
      .replace(`{{1}}`, newState.hasOwnProperty(1) ? newState[1].Text : `{{1}}`)
      .replace(`{{2}}`, newState.hasOwnProperty(2) ? newState[2].Text : `{{2}}`)
      .replace(`{{3}}`, newState.hasOwnProperty(3) ? newState[3].Text : `{{3}}`);

    setPreview(previewValue);

    setDynamicParams(newState)
  }

  //const onPick = img => setImage(img)

  const renderImage = () => {
    //console.log('renderImage '+selectedTemplate.hasOwnProperty("id"))
    if(!selectedTemplate.hasOwnProperty("id")) { return }

    if(selectedTemplate.hasOwnProperty("header") && selectedTemplate.header.type.includes("image")) {
      //console.log(image)
      if(image){
        let src=image
        return (
         <div className="image-preview" > 
         <img src={src} alt='preview' />
         </div> 
         )
      }else{
        return
      }
    }
  }

  const renderDynamicHeader = () => {
    if(!selectedTemplate.hasOwnProperty("id")) { return }

    if(selectedTemplate.hasOwnProperty("header") && selectedTemplate.header.type === "image") {
      return (
         <div>
           <Tooltip content="Selecciona la imagen">
                    <select onChange={handleChangeImage} name='cmbImage' className="form-control form-control-sm" required>
                      <option defaultValue value="">Selecciona la imagen</option>
                      {selectedTemplate.header.catalog.map((image, i) => <option value={image} key={image}>{image.slice(image.lastIndexOf("/")+1)}</option>)}
                    </select>
                  </Tooltip>

        </div>
      )
    }
  }

  const renderDynamicFields = () => {
    if(!selectedTemplate.hasOwnProperty("id")) { return }

    return selectedTemplate.exportFields.split(",").splice(1).map((f, index) => {
      return <div className="row align-items-center" key={`${selectedTemplate.id}${f}`}>
        <div className="col">
          <div className="input-group mb-3 input-group-sm">
            <input
              onChange={handleChangeOnDynamic.bind(this, index)}
              required
              type="text"
              className="form-control"
              placeholder={f} />
          </div>
        </div>
      </div>
    })
  }

  return (
    <Dialog
      icon="new-person"
      onClose={props.close}
      title='Nuevo mensaje'
      isOpen= {props.isOpen}>
      <form onSubmit={handleSubmit}>
        <div className={Classes.DIALOG_BODY}>
          <div className="column py-3">
            <select onChange={handleChange} name='cmbTemplate' className="form-control form-control-lg w-100" required>
              <option defaultValue value="">Selecciona una plantilla</option>
              {props.templateList.map(template => <option key={template.id}>{template.id}</option>)}
            </select>
          </div>

          <hr/>

          <div className="column">
             <label className="label"><strong>Parámetros:</strong></label>
          </div>

          {renderDynamicHeader()}

          {renderImage()}

          {renderDynamicFields()}

          <div className="column">
             <label className="label"><strong>Vista previa:</strong></label>
             <div className="control">
               <div className="content" dangerouslySetInnerHTML={{__html: preview}} style={{height: "120px",border: "rgb(170, 170, 170) 1px dotted",padding: "10px", fontStyle: "italic",background:"white"}}></div>
             </div>
              <div className="control">
                <div id='div-status' className="content" style={{maxHeight: '120px', color: 'red'}}>
                </div>
             </div>
          </div>
        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Tooltip content="Cierra el recuadro sin enviar">
              <Button onClick={props.close}>Cancelar</Button>
            </Tooltip>
            <Tooltip content="Enviar mensaje">
              <Button type="submit" intent={Intent.PRIMARY} loading={loading}>Enviar</Button>
            </Tooltip>
          </div>
        </div>
      </form>
    </Dialog>
  )
}

export default MessageTemplateDialog;
